import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private router : Router, private authService : AuthService) { }

  canActivate():boolean{
    if(this.authService.isAuthenticated()){
      return true
    }
    else{
      this.router.navigateByUrl("/")
      return false
    }
  }
}
